import * as types from "../ActionTypes";
import { showToast } from "../../../utils/styles/toastUtils";
import { toast } from "react-toastify";

export const logoutActionInitiate = (navigate) => {
    return (dispatch) => {
        try {
            dispatch({ type: types.LOGOUT_START });

            // Clear all localStorage items and reset theme to default (light)
            localStorage.clear();
            sessionStorage.clear();
            document.documentElement.setAttribute('data-theme', 'light');
            window.dispatchEvent(new Event('app:logout'));

            dispatch({ type: types.RESET_APP_STATE });
            dispatch({ type: types.CURRENT_USER_GET_RESET });
            dispatch({ type: types.POST_BUSINESS_UPGRADE_REQUEST_RESET });
            
            // Dispatch success
            dispatch({
                type: types.LOGOUT_SUCCESS,
                payload: { message: "Logged out successfully!" },
            });

            // Show success toast
            toast.dismiss();
            showToast.success("Logged out successfully!");

            // Navigate to login page immediately
            navigate("/");

        } catch (error) {
            const errorMessage = error?.message || "Logout failed";

            dispatch({
                type: types.LOGOUT_ERROR,
                payload: errorMessage,
            });

            showToast.error(errorMessage);

            // Even if there's an error, still try to navigate to login
            navigate("/");
        }
    };
};
